import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { MatSidenav } from "@angular/material";
import { environment } from "../../environments/environment";
import { utilities } from "../../utils/utilities";
import { SidenavService } from "../../services/side-bar.service";
import { AuthMsgService } from "../../auth/auth-msg.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-template-form",
  templateUrl: "./template-form.component.html",
  styleUrls: ["./template-form.component.css"],
})
export class TemplateFormComponent implements OnInit, OnDestroy {
  @ViewChild("sidenav") public sidenav: MatSidenav;

  public primaryHexCode: string = utilities.GetPrimaryColor(); // "transparent";
  public version: string = environment.version;
  screenWidth: number;
  public IsAuthenticated = false;
  public HideSideNav = false;
  subAuth: Subscription;
  subSideNav: Subscription;

  constructor(
    private sidenavService: SidenavService,
    private authMsgService: AuthMsgService
  ) {
    this.screenWidth = window.innerWidth;
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
    };
  }

  ngOnInit(): void {
    this.sidenavService.setSidenav(this.sidenav);

    this.subAuth = this.authMsgService.getMessage().subscribe((message) => {
      setTimeout(() => {
        this.IsAuthenticated = message as boolean;
      });
    });

    this.subSideNav = this.authMsgService
      .sideNavHidden()
      .subscribe((message) => {
        setTimeout(() => {
          this.HideSideNav = !(message as boolean);
        });
      });
  }

  ngOnDestroy(): void {
    // unsubscribe to ensure no memory leaks
    this.subAuth.unsubscribe();
  }
}
